import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, Footer } from '../Common';
import Accessories from '../../Common/Accessories';

/* Placeholder imagery (reuse ABC-SE product assets until CLS cataloch ships) */
import bulkFest from '../../../../assets/abc-se/accessories/party-overall.jpg';
import bulkVogn from '../../../../assets/abc-se/accessories/standard-overall.jpg';
import accSprayCans from '../../../../assets/abc-se/products/acc-spray-cans.jpg';
import accMarkers from '../../../../assets/abc-se/products/acc-markers.jpg';
import accPaintGirl from '../../../../assets/abc-se/products/acc-paint-girl.jpg';
import accConfettiGirl from '../../../../assets/abc-se/products/acc-confetti-girl.jpg';
import accPointtrojen from '../../../../assets/abc-se/products/acc-pointtrojen.jpg';
import accSprayCans2 from '../../../../assets/abc-se/products/acc-spray-cans-2.jpg';
import accSprayCans3 from '../../../../assets/abc-se/products/acc-spray-cans-3.jpg';
import accSprayCans4 from '../../../../assets/abc-se/products/acc-spray-cans-4.jpg';

/* ── Product cataloch (CLS-FI — Finnish copy) ── */
const BULK_PRODUCTS = [
  { id: 'bulk-1', slug: 'partyoverallen', image: bulkFest, imageAlt: 'Juhlahaalari', title: 'JUHLAHAALARI', price: '159 €' },
  { id: 'bulk-2', slug: 'flakoverallen', image: bulkVogn, imageAlt: 'Vaunuhaalari', title: 'VAUNUHAALARI', price: '159 €' },
];

const ACCESSORY_PRODUCTS = [
  { id: 'acc-1', slug: 'spraymaling', image: accSprayCans, imageAlt: 'Spraymaali', title: 'SPRAYMAALI', price: '59 €' },
  { id: 'acc-2', slug: 'tuscher', image: accMarkers, imageAlt: 'Tussit', title: 'TUSSIT', price: '79 €' },
  { id: 'acc-3', slug: 'tekstilfärg', image: accPaintGirl, imageAlt: 'Tekstiiliväri', title: 'TEKSTIILIVÄRI', price: '49 €' },
  { id: 'acc-4', slug: 'konfetti-kit', image: accConfettiGirl, imageAlt: 'Konfettisetti', title: 'KONFETTISETTI', price: '39 €' },
];

const BOTTOM_PRODUCTS = [
  { id: 'bot-1', slug: 'pointtrojen', image: accPointtrojen, imageAlt: 'Point-paita', title: 'POINT-PAITA', price: '89 €' },
  { id: 'bot-2', slug: 'spraymaling-sat', image: accSprayCans2, imageAlt: 'Spraymaalisetti', title: 'SPRAYMAALISETTI', price: '179 €' },
  { id: 'bot-3', slug: 'spraymaling-neon', image: accSprayCans3, imageAlt: 'Spraymaali Neon', title: 'SPRAYMAALI NEON', price: '69 €' },
  { id: 'bot-4', slug: 'spraymaling-metallic', image: accSprayCans4, imageAlt: 'Spraymaali Metallic', title: 'SPRAYMAALI METALLIC', price: '99 €' },
];

const TABS = [
  { key: 'alle', label: 'Kaikki' },
  { key: 'overalls', label: 'Haalarit' },
  { key: 'accessories', label: 'Tarvikkeet' },
];

const CLSFIAccessories = () => {
  const navigate = useNavigate();
  return (
    <Accessories
      brand="CLS"
      Header={Header}
      Footer={Footer}
      bannerTag="Vedenpitävä ja kestävä"
      bannerTitle="Haalarit & muut"
      tabs={TABS}
      showTabs={false}
      bulkProducts={BULK_PRODUCTS}
      accessoryProducts={ACCESSORY_PRODUCTS}
      bottomProducts={BOTTOM_PRODUCTS}
      fullwidth={{
        subtitle: 'YLI 75 000 ASIAKASTA VUOSITTAIN',
        mainCopy: 'Tarjoamme nopean toimituksen ja houkuttelevat pakettiratkaisut, ja voit tilata turvallisesti yli 100 vuoden kokemuksella.',
        tags: ['Kampanja', 'Kampanja', 'Kampanja'],
      }}
      onBulkClick={(slug) => navigate(`/clothing/cls-fi/bulk-product/${slug}`)}
      onAccessoryClick={(slug) => navigate(`/clothing/cls-fi/product-details/${slug}`)}
    />
  );
};

export default CLSFIAccessories;
